import { useRef } from "react";
import { motion, useInView } from "motion/react";
import { siteData } from "../../data/mock";

const spring = { type: "spring", damping: 80, stiffness: 400, mass: 1 };

const StepCard = ({ step, index, inView }) => {
  const colors = ["#008055", "#D98A8C", "#E1C567"];
  const bgColors = ["rgba(0,128,85,0.08)", "rgba(217,138,140,0.1)", "rgba(225,197,103,0.1)"];

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ ...spring, delay: 0.15 + index * 0.15 }}
      className="relative flex flex-col items-center text-center"
    >
      {/* Number Circle */}
      <div
        className="w-16 h-16 rounded-full flex items-center justify-center mb-6"
        style={{ backgroundColor: bgColors[index] }}
      >
        <span
          className="text-xl font-semibold"
          style={{ color: colors[index] }}
        >
          {step.number}
        </span>
      </div>

      {/* Connector line (not on last) */}
      {index < 2 && (
        <div className="hidden lg:block absolute top-8 left-[calc(50%+48px)] w-[calc(100%-96px)] h-[2px] bg-[#E6E4EB]">
          <motion.div
            initial={{ scaleX: 0 }}
            animate={inView ? { scaleX: 1 } : {}}
            transition={{ delay: 0.5 + index * 0.2, duration: 0.6 }}
            className="h-full origin-left"
            style={{ backgroundColor: colors[index] }}
          />
        </div>
      )}

      <h3 className="text-[#0A0A0A] text-xl font-medium mb-3 tracking-tight">
        {step.title}
      </h3>
      <p className="text-[#3C3B3D] text-[15px] leading-relaxed max-w-[280px]">
        {step.description}
      </p>
    </motion.div>
  );
};

export const HowItWorksSection = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const { howItWorks } = siteData;

  return (
    <section ref={ref} id="how-it-works" className="py-20 md:py-28 bg-[#FAFAFA]">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ ...spring }}
          className="text-center mb-16"
        >
          <span className="inline-block text-[#008055] text-sm font-medium bg-[#008055]/8 rounded-full px-4 py-1.5 mb-4">
            Simple Process
          </span>
          <h2
            className="text-[#0A0A0A] leading-tight tracking-tight"
            style={{ fontSize: "clamp(28px, 4vw, 40px)", fontWeight: 500 }}
          >
            {howItWorks.headline}
            <span className="text-[#008055]">{howItWorks.headlineAccent}</span>
          </h2>
        </motion.div>

        {/* Steps */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-8">
          {howItWorks.steps.map((step, i) => (
            <StepCard key={i} step={step} index={i} inView={inView} />
          ))}
        </div>
      </div>
    </section>
  );
};
